import React from 'react';
import { useLocation } from 'react-router-dom';
import { SettingsIcon } from '@shopify/polaris-icons';
import { Navigation } from '@shopify/polaris';
import { AuthenticationContext } from '../../../homeModules/auth/contexts/AuthenticationContext';

const DevelopmentSidebar: React.FC = () => {
  const location = useLocation();
  const { user } = React.useContext(AuthenticationContext);

  const isAdminUser = user?.modules?.some((module) => module.value === 'admin' && parseInt(module.tier) > 2);

  const navigationItems = [];

  if (isAdminUser) {
    navigationItems.push({
      label: 'Admin',
      url: '/admin/user_management',
      icon: SettingsIcon as any,
      matches: true,
      subNavigationItems: [
        {
          url: '/developers/callback_results',
          disabled: false,
          label: 'Callback Results',
        },
        {
          url: '/developers/servman_sql_logs',
          disabled: false,
          label: 'Servman Logs',
        },
        {
          url: '/admin/xoi_quote_records',
          disabled: false,
          label: 'XOI Quote Records',
        },
      ],
    });
  }

  return (
    <Navigation location={location.pathname}>
      <Navigation.Section items={navigationItems} />
    </Navigation>
  );
};

export default DevelopmentSidebar;
